import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserContext } from '@bi-studio/shared';

interface AuthState {
    user: UserContext | null;
    token: string | null;
    isAuthenticated: boolean;
}

const initialState: AuthState = {
    user: null,
    token: localStorage.getItem('bi_studio_token'),
    isAuthenticated: !!localStorage.getItem('bi_studio_token'),
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ user: UserContext; token: string }>) => {
            const { user, token } = action.payload;
            state.user = user;
            state.token = token;
            state.isAuthenticated = true;
        },
        updateUser: (state, action: PayloadAction<UserContext>) => {
            state.user = action.payload;
        },
        logoutAction: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
        },
    },
});

export const { setCredentials, updateUser, logoutAction } = authSlice.actions;

export default authSlice.reducer;

